import UserPool from "../cognitoConfig";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";

export function signUpUser(username: string, password: string, email: string) {
  return new Promise((resolve, reject) => {
    const attributeEmail = new CognitoUserAttribute({
      Name: "email",
      Value: email,
    });

    UserPool.signUp(
      username,
      password,
      [attributeEmail],
      [],
      (err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      }
    );
  });
}
